<template>
  <div>
    <ModalComponent
      class="[&_.full-screen-modal-close-button]:!hidden [&_.dialogOverlay]:!opacity-0 [&_.dialogNotVisible]:translate-y-1/2 [&_.dialogNotVisible]:!scale-100 [&_.dialogNotVisible]:!top-0 [&_.full-screen-modal-bg]:!bg-transparent"
      hashBase="new-teammate"
      ref="dialog"
      headerBg="#fff"
    >
      <div class="w-full h-full relative">
        <div class="w-full h-full absolute" @click="$refs.dialog.hide()"></div>
        <TeammateUpdater :teammateData="teammateToUpdate" />
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '../utils/ModalComponentFullScreen.vue'
import TeammateUpdater from './TeammateUpdater.vue'

export default defineComponent({
  name: 'TeammateUpdaterDialog',
  components: { TeammateUpdater, ModalComponent },
  props: {},
  data() {
    return {
      eventsIds: [],
      teammateToUpdate: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'new_teammate_update_required',
      this.showDetails,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showDetails(teammate) {
      this.teammateToUpdate = teammate
      setTimeout(() => {
        this.$refs.dialog.show()
      }, 300)
    },
  },
  computed: {},
})
</script>
